import { Alert, MultiSelect, SwitchInput } from 'corso-admin-ui';
import {
  ClaimResolutionMethodEnum,
  shippingClaimResolutionMethodName,
} from 'corso-types';
import { Controller } from 'react-hook-form';
import { useAutomationFormContext } from '~/features/settings/automations/hooks/useAutomationForm';
import { useConfigSettings } from '~/hooks/useConfigSettings';

const allowableResolutionMethods = Object.values(ClaimResolutionMethodEnum);

export function EventShippingClaimAllowedResolutions() {
  const { control } = useAutomationFormContext();
  const { data } = useConfigSettings(
    ({ shippingProtection }) => shippingProtection,
  );

  const giftCardIdSet = !!data?.giftCardProductIdFromPlatform;

  return (
    <div className="flex flex-col gap-4">
      <Controller
        control={control}
        name="event.params.shippingClaimResolutionMethods"
        render={({ field, fieldState }) => (
          <MultiSelect
            label="Allowed Resolution Methods"
            details="The resolution methods available when resolving the shipping claim."
            placeholder="Select Resolution Methods"
            options={allowableResolutionMethods.map((method) => ({
              label: shippingClaimResolutionMethodName[method],
              value: method,
            }))}
            value={field.value.map((method) => ({
              label: shippingClaimResolutionMethodName[method],
              value: method,
            }))}
            onChange={(selections) =>
              field.onChange(
                allowableResolutionMethods.filter((method) =>
                  selections.some(({ value }) => value === method),
                ),
              )
            }
            error={fieldState.error?.message}
          />
        )}
      />

      {!giftCardIdSet && (
        <Alert heading="In order to offer a gift card as a resolution, the gift card product ID must be set." />
      )}
      <Controller
        control={control}
        name="event.params.isGiftCardEnabled"
        defaultValue={false} // prevent uncontrolled input warning
        render={({ field: { onChange, value }, fieldState }) => (
          <SwitchInput
            id="ship-claim-gift-card-enabled"
            label="Allow Gift Card"
            details="Offer a gift card in place of a reorder when resolving the shipping claim."
            checked={value ?? false}
            onChange={onChange}
            error={fieldState.error?.message}
            disabled={!giftCardIdSet}
          />
        )}
      />
    </div>
  );
}
